
import React from 'react'

import './Button.scss'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary'
  size?: 'sm' | 'lg'
}

const Button = (props: Props) => {

  const { variant, size, children, ...rest } = props

  return (
    <button
      {...rest}
      className={`btn button button-${variant || 'secondary'}`}
    >
      {children && (
        <div className='children'>
          {children}
        </div>
      )}
    </button>
  )
}

export default Button
